/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AgentOwnerProfile = {
  displayName: string;
  photoUrl?: string | undefined;
};

/** @internal */
export const AgentOwnerProfile$inboundSchema: z.ZodMiniType<
  AgentOwnerProfile,
  unknown
> = z.pipe(
  z.object({
    display_name: z.string(),
    photo_url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "display_name": "displayName",
      "photo_url": "photoUrl",
    });
  }),
);

export function agentOwnerProfileFromJSON(
  jsonString: string,
): SafeParseResult<AgentOwnerProfile, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentOwnerProfile$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentOwnerProfile' from JSON`,
  );
}
